// Navigation reference for AFC Group Connect.
//
// Single source of truth mapping every menu entry to its **page id**, **slug**,
// and **page name** (per create-frontend-layout-components Policy 8). The layout
// nav is driven from this tree and routes by SLUG (never by page id). When
// ui-components-from-reference generates a page, it registers a route at that
// page's slug; until then the slug still resolves (the router catch-all serves
// the themed 404), so the nav never dead-ends.
//
// `pageId` is the RawHTMLDesign page id (PageDesignMap key) for traceability.

export const menuData = {
  items: [
    {
      label: 'Dashboard',
      labelKey: 'nav.dashboard',
      slug: 'connector-dashboard',
      pageId: 'da2441a5-b5e5-466d-a96c-7b4a40501a17',
      name: 'Connector Dashboard',
      icon: 'fa-solid fa-house',
      connectorOnly: true,
    },
    {
      label: 'New Referral',
      labelKey: 'nav.newReferral',
      slug: 'new-referral',
      pageId: 'new-referral',
      name: 'New Referral',
      icon: 'fa-solid fa-circle-plus',
      connectorOnly: true,
    },
    {
      label: 'My Profile',
      labelKey: 'nav.myProfile',
      slug: 'connector-profile',
      pageId: 'connector-profile',
      name: 'Connector Profile',
      icon: 'fa-solid fa-circle-user',
      connectorOnly: true,
    },
    {
      label: 'Commission Processing',
      slug: 'commission-processing-queue',
      pageId: 'ab402838-5326-4c77-a497-38d621f9b1d8',
      name: 'Commission Processing Queue',
      icon: 'fa-solid fa-calculator',
    },
    {
      label: 'Accreditation Review',
      slug: 'connector-accreditation-management',
      pageId: 'f5bbc131-950a-4d5f-977a-084f8dc120e8',
      name: 'Connector Accreditation Management',
      icon: 'fa-solid fa-id-card',
    },
    {
      label: 'Referrals',
      slug: 'referral-queue',
      pageId: 'bd233111-a114-4648-941f-af23e27618ae',
      name: 'Referral Queue',
      icon: 'fa-solid fa-rectangle-list',
    },
    {
      label: 'Administration',
      icon: 'fa-solid fa-gear',
      children: [
        {
          label: 'Admin Dashboard',
          slug: 'admin-dashboard',
          pageId: 'da801832-c670-4c2b-81f8-0425c2f06221',
          name: 'Admin Dashboard',
          icon: 'fa-solid fa-chart-line',
        },
        {
          label: 'Products & Comm',
          slug: 'commission-configuration-approvals',
          pageId: '92032874-8db0-4659-9209-fbd9d492b536',
          name: 'Products & Comm',
          icon: 'fa-solid fa-percent',
        },
        {
          label: 'User Directory',
          slug: 'user-administration-security',
          pageId: '378b6e7b-38db-47a4-bfcc-2eb098dbb6ce',
          name: 'User Administration & Security',
          icon: 'fa-solid fa-user-shield',
        },
        {
          label: 'Notification Management',
          slug: 'notification-management',
          pageId: '7c7e8369-5242-44a8-8bca-c6669b6a6d91',
          name: 'Notification Management',
          icon: 'fa-solid fa-bell',
        },
        {
          label: 'Branding',
          slug: 'branding-management',
          pageId: 'branding-management',
          name: 'Branding & Appearance',
          icon: 'fa-solid fa-palette',
        },
        {
          label: 'Integrations',
          slug: 'integrations-management',
          pageId: 'integrations-management',
          name: 'Integrations & External APIs',
          icon: 'fa-solid fa-plug',
        },
        {
          label: 'Reports',
          slug: 'reports-management',
          pageId: 'reports-management',
          name: 'Reports',
          icon: 'fa-solid fa-chart-column',
        },
        {
          label: 'Branch Maintenance',
          slug: 'branch-management',
          pageId: 'branch-management',
          name: 'Branch Maintenance',
          icon: 'fa-solid fa-code-branch',
        },
        {
          label: 'Role Permissions',
          slug: 'role-permission-management',
          pageId: 'b193b779-44c4-4789-99ff-db6d6f36d54f',
          name: 'Role & Permission Management',
          icon: 'fa-solid fa-shield-halved',
        },
        {
          label: 'Security Logs',
          slug: 'audit-logs-security-monitoring',
          pageId: 'f77f257d-7c39-4486-8cc8-51e4fd913a31',
          name: 'Audit Logs & Security Monitoring',
          icon: 'fa-solid fa-receipt',
        },
      ],
    },
    {
      label: 'Export & Handoff',
      slug: 'export-handoff-management',
      pageId: '9034da8e-944b-4fa1-985d-974bfa325260',
      name: 'Export & Handoff Management',
      icon: 'fa-solid fa-file-export',
    },
  ],
  defaultSlug: 'connector-dashboard',
};

// Flat lookup: slug -> menu entry (leaf items only). Useful for breadcrumbs and
// active-link resolution.
export const menuBySlug = (() => {
  const map = {};
  const walk = (nodes) => {
    for (const node of nodes) {
      if (node.slug) map[node.slug] = node;
      if (node.children) walk(node.children);
    }
  };
  walk(menuData.items);
  return map;
})();

export default menuData;
